import React, { useState } from 'react';
import { ImageContainer, Loading, TestImage } from './loadingStyles';

type ImageProps = {
	src: string;
};

const LoadingImage: React.FC<ImageProps> = ({ src }) => {
	const [loading, setLoading] = useState(true);
	const [showImages, setShowImages] = useState(false);

	const onComplete = () => {
		setLoading(false);
	};
	return (
		<ImageContainer>
			{/* {loading && <Loading />} */}
			<Loading $loading={loading} />
			<TestImage
				onLoad={onComplete}
				onError={onComplete}
				src={src}
				$loading={loading}
			/>
		</ImageContainer>
	);
};

export default LoadingImage;
